import { render } from "./CNavigation.vue?vue&type=template&id=3356d9f7&scoped=true"
const script = {}

import "./CNavigation.vue?vue&type=style&index=0&id=3356d9f7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3356d9f7"]])

export default __exports__